import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Radar } from "lucide-react";

// Shared "On Hold / Parked" capture block — shown when status === "parked".
export default function ParkFields({ form, set, testPrefix }) {
  if (form.status !== "parked") return null;
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-3 space-y-2.5" data-testid={`${testPrefix}-park-box`}>
      <p className="text-xs font-bold text-amber-800 flex items-center gap-1.5">
        <Radar className="h-3.5 w-3.5" /> Going On the Radar — keep visibility on this parked item
      </p>
      <div>
        <Label className="text-xs">Why is this on hold / parked? <span className="text-red-500">*</span></Label>
        <Textarea rows={2} value={form.parked_reason || ""} onChange={(e) => set("parked_reason", e.target.value)}
          placeholder="Quick explanation so the team remembers the context…" className="mt-1 bg-white" data-testid={`${testPrefix}-park-reason`} />
      </div>
      <div>
        <Label className="text-xs">Tentative revisit date <span className="text-red-500">*</span></Label>
        <Input type="date" value={form.parked_revisit || ""} onChange={(e) => set("parked_revisit", e.target.value)}
          className="mt-1 bg-white w-44" data-testid={`${testPrefix}-park-revisit`} />
      </div>
    </div>
  );
}

export const validateParked = (form, toastFn) => {
  if (form.status !== "parked") return true;
  if (!(form.parked_reason || "").trim()) { toastFn("Please give a quick explanation for parking this item."); return false; }
  if (!form.parked_revisit) { toastFn("Please set a tentative revisit date so it stays visible."); return false; }
  return true;
};

export const ParkedBadge = ({ item, testid }) => (
  item.status === "parked" ? (
    <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded-full bg-sky-100 text-sky-700" title={`${item.parked_reason || ""}${item.parked_revisit ? ` — revisit ${item.parked_revisit}` : ""}`} data-testid={testid}>
      <Radar className="h-3 w-3" /> Parked{item.parked_revisit ? ` · revisit ${item.parked_revisit}` : ""}
    </span>
  ) : null
);
